import React from 'react';
import TablaConfgFechasRetencion from '../components/impuesto1x500/tablaConfigFecha';

function Retencionfecha() {
  return (
 <TablaConfgFechasRetencion />
  );
}

export default Retencionfecha;




// WEBPACK FOOTER //
// ./src/pages/fecharetencion.js